<script>
  import {getContext} from 'svelte';
  import {rankings$} from '../stream';
  import RankTopN from './RankTopN.svelte';
  import lang from '../TradeCompetitionPage.lang';

  const LG = getContext('LG');
</script>

<style>
  .rankings {
    position: relative;
  }
  .ranking-update-frequency {
    padding-top: 80px;
    color: #fff;
  }
  .ranking-update-frequency .label {
    font-size: 32px;
    font-weight: bold;
  }
  .ranking-update-frequency .live-mark {
    border-radius: 2px;
    padding: 2px 5px;
    background: #cf1f1f;
  }
  @media screen and (max-width: 640px) {
    .ranking-update-frequency {
      padding-top: 40px;
    }
    .ranking-update-frequency .label {
      font-size: 16px;
    }
  }
</style>

{#if $rankings$.trading.length}
  <div class="rankings">
    <div class="ranking-update-frequency">
      <div class="label">{LG(lang.Rankings)}</div>
      <div class="update-info">
        <span class="live-mark">{LG(lang.Live)}</span>
        {LG(lang.RankingUpdateTip)}
      </div>
    </div>
    <RankTopN title={LG(lang.TradeRankTitle)} ranks={$rankings$.trading} />
  </div>
{/if}
